import { IFeatureBase, IFeatureGroupBase } from '../../models/features';
import { IUserBase, UserExperience, UserGender } from '../../models/users';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IUpdateUserProps {
  userId: string;
  bio?: string;
  birthDate?: Date;
  categoryId?: string;
  cpf?: string;
  email: string;
  experience?: UserExperience;
  gender?: UserGender;
  featureGroupId?: string;
  healthCheck?: Date;
  hostId?: string;
  name: string;
  onboardingPending?: boolean;
  phone?: string;
  ventureId?: string | null;
}

export interface IUpdateUserDetailedFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
}

export interface IUpdatedUser extends IUserBase {
  featureGroup: IUpdateUserDetailedFeatureGroup;
}

export const updateUsersService = async ({
  userId,
  bio,
  birthDate,
  categoryId,
  cpf,
  email,
  experience,
  featureGroupId,
  gender,
  healthCheck,
  hostId,
  name,
  onboardingPending,
  phone,
  ventureId,
}: IUpdateUserProps): Promise<IUpdatedUser> => {
  const { data } = await wbsBookingsApi.put<IUpdatedUser>(`/users/${userId}`, {
    bio,
    birthDate,
    categoryId,
    cpf,
    email,
    experience,
    featureGroupId,
    gender,
    healthCheck,
    hostId,
    name,
    onboardingPending,
    phone,
    ventureId,
  });

  return data;
};
